import { ResourceTypeExplorer } from '@dbt-labs/dbt-dag';

import { ResourceNodeType } from '@/__generated__/graphql';

export type ResourceTypeMapping = {
  [K in ResourceTypeExplorer]?: ResourceNodeType;
};

export const RESOURCE_TYPE_MAPPING: ResourceTypeMapping = {
  model: ResourceNodeType.Model,
  source: ResourceNodeType.Source,
  test: ResourceNodeType.Test,
  exposure: ResourceNodeType.Exposure,
  metric: ResourceNodeType.Metric,
  semantic_model: ResourceNodeType.SemanticModel,
  seed: ResourceNodeType.Seed,
  macro: ResourceNodeType.Macro,
  snapshot: ResourceNodeType.Snapshot,
  saved_query: ResourceNodeType.SavedQuery,
};

type FilterableResourceType = keyof typeof RESOURCE_TYPE_MAPPING;

export const ALL_FILTERABLE_RESOURCE_TYPES: readonly FilterableResourceType[] = [
  'model',
  'source',
  'semantic_model',
  'exposure',
  'metric',
  'test',
  'seed',
  'macro',
  'snapshot',
  'saved_query',
] as const;

export const ALL_DIVEABLE_RESOURCE_TYPES: readonly FilterableResourceType[] = [
  'model',
] as const;
